import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import "./contact.css";
import { submitContactForm } from "../../api/contact.api";

const ContactPage = () => {
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    comments: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    if (
      !formData.firstName.trim() ||
      !formData.lastName.trim() ||
      !formData.mobile.trim() ||
      !formData.email.trim()
    ) {
      return "Please fill in all required fields";
    }

    if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      return "Please enter a valid email address";
    }

    if (!/^\d{8,15}$/.test(formData.mobile)) {
      return "Please enter a valid mobile number";
    }

    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setErrorMsg("");
    setSuccessMsg("");

    const validationError = validateForm();
    if (validationError) {
      setErrorMsg(validationError);
      return;
    }

    setLoading(true);

    try {
      const res = await submitContactForm({
        name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        phone_number: formData.mobile,
        comments: formData.comments,
      });

      setSuccessMsg(res?.message || "Message sent successfully");

      setFormData({
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        comments: "",
      });
    } catch (err) {
      setErrorMsg(err.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact">
      <Helmet>
        <title>Contact Us | 164 Diecast Zone</title>
        <meta
          name="description"
          content="Get in touch with 164 Diecast Zone for questions about orders, memberships, or diecast collections."
        />
        <link rel="canonical" href="https://164diecastzone.com/contact-us" />
        <meta property="og:title" content="Contact Us | 164 Diecast Zone" />
        <meta
          property="og:description"
          content="Get in touch with 164 Diecast Zone for questions about orders, memberships, or diecast collections."
        />
        <meta property="og:url" content="https://164diecastzone.com/contact-us" />
      </Helmet>

      <div className="breadcrumb11">
        <div className="page-container">
          <span>Home</span>{" "}
          <span className="highlight"> / </span>{" "}
          <span>Contact Us</span>
        </div>

      </div>


      <div className="contact__container">
        <section className="contact__hero">
          <h1 className="contact__title">
            LET&apos;S <span className="contact__highlight">CONNECT</span>
          </h1>
          <p className="contact__subtitle">
            Need support with a pre-order, your collection, or wholesale deals?
            Reach out, we’re happy to assist.
          </p>
        </section>

        <section className="contact__card">
          <h2 className="contact__section-title">PERSONAL DETAILS</h2>

          <form className="contact__form" onSubmit={handleSubmit}>
            <div className="contact__row">
              <div className="contact__field">
                <label>First Name <span>*</span></label>
                <input
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder="Joe"
                />
              </div>

              <div className="contact__field">
                <label>Last Name <span>*</span></label>
                <input
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder="Mathew"
                />
              </div>
            </div>

            <div className="contact__row">
              <div className="contact__field">
                <label>Mobile Number <span>*</span></label>
                <input
                  name="mobile"
                  value={formData.mobile}
                  onChange={handleChange}
                  placeholder="09876543210"
                />
              </div>

              <div className="contact__field">
                <label>Email Address <span>*</span></label>
                <input
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="joe@gmail.com"
                />
              </div>
            </div>

            <div className="contact__field contact__field--full">
              <label>Comments</label>
              <textarea
                name="comments"
                rows="4"
                value={formData.comments}
                onChange={handleChange}
                placeholder="#123, Joe M, 2nd floor..."
              />
            </div>

            {successMsg && (
              <p className="contact__success">{successMsg}</p>
            )}

            {errorMsg && (
              <p className="contact__error">{errorMsg}</p>
            )}

            <div className="contact__footer">
              <button
                type="submit"
                className="contact__submit"
                disabled={loading}
              >
                {loading ? "SENDING..." : "SEND"}
              </button>

              <span className="contact__note">* REQUIRED FIELDS</span>
            </div>
          </form>
        </section>

        <div className="contact__row1">
          <section className="contact__card">
            <h2 className="contact__section-title">ADDRESS</h2>
            <div className="contact__text">
              <p>164 Diecastzone</p>
              <p>Sarjapur Road</p>
              {/* <p>HSR Layout</p> */}
              <p>Bangalore 560001</p>
              <p>Karnataka, India</p>
            </div>
          </section>

          {/* Vertical Divider */}
          <div className="contact__divider"></div>

          <section className="contact__card">
            <h2 className="contact__section-title">SHIPPING INQUIRIES</h2>

            <div className="contact__text">
              <div className="contact__details">
                <p>
                  <strong>Contact Name:</strong> Srivatsav
                </p>

                <p>
                  <strong>Contact Number:</strong>{" "}
                  <a href="tel:+917907628677">
                    7907628677
                  </a>
                </p>
              </div>
            </div>
          </section>
        </div>


      </div>
    </div>
  );
};

export default ContactPage;
